"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.is-array.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCalculator = exports.testables = void 0;
require("core-js/modules/es.number.constructor.js");
var _react = require("react");
var _numberUtils = require("./utils/numberUtils");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _getOutputs = function _getOutputs(_ref) {
  var appreciation = _ref.appreciation,
    downPayment = _ref.downPayment,
    insurance = _ref.insurance,
    mortgageInterest = _ref.mortgageInterest,
    otherExpenses = _ref.otherExpenses,
    propertyTax = _ref.propertyTax,
    purchasePrice = _ref.purchasePrice,
    rent = _ref.rent,
    years = _ref.years;
  // mortgage
  var MONTHS_IN_LOAN = 30 * 12;
  var downPaymentTotal = Number(purchasePrice) * (Number(downPayment) / 100);
  var loanPrincipal = Number(purchasePrice) - downPaymentTotal;
  var monthlyInterestRate = Number(mortgageInterest) / 12 / 100;
  var monthlyMortgagePayment = loanPrincipal * (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, MONTHS_IN_LOAN)) / (Math.pow(1 + monthlyInterestRate, MONTHS_IN_LOAN) - 1);
  var remainingLoanPrincipal = Math.max(0, loanPrincipal - monthlyMortgagePayment * 12 * Number(years));
  var totalEquity = downPaymentTotal + (loanPrincipal - remainingLoanPrincipal);

  // expenses
  var monthlyTaxes = Number(purchasePrice) * (Number(propertyTax) / 100) / 12;
  var monthlyTotalExpenses = Number(otherExpenses) + monthlyMortgagePayment + monthlyTaxes + Number(insurance) / 12;

  // gains
  var appreciatedHomevalue = Number(purchasePrice) * Math.pow(1 + Number(appreciation) / 100, Number(years));
  var cashFlow = Number(rent) * 12 - monthlyTotalExpenses * 12;

  // outputs
  var capRate = cashFlow / appreciatedHomevalue;
  var grossYield = Number(rent) * 12 / appreciatedHomevalue;
  var roi = cashFlow / totalEquity;
  var annualReturn = cashFlow;
  var totalReturn = appreciatedHomevalue - Number(purchasePrice) + cashFlow * Number(years);
  return {
    capRate: (0, _numberUtils.numToPercentage)(capRate),
    grossYield: (0, _numberUtils.numToPercentage)(grossYield),
    roi: (0, _numberUtils.numToPercentage)(roi),
    annualReturn: (0, _numberUtils.numToCurrency)(annualReturn),
    totalReturn: (0, _numberUtils.numToCurrency)(totalReturn)
  };
};
var testables = exports.testables = {
  getOutputs: _getOutputs
};
var useCalculator = exports.useCalculator = function useCalculator() {
  // inputs
  var _useState = (0, _react.useState)('5'),
    _useState2 = _slicedToArray(_useState, 2),
    years = _useState2[0],
    setYears = _useState2[1];
  var _useState3 = (0, _react.useState)('20'),
    _useState4 = _slicedToArray(_useState3, 2),
    downPayment = _useState4[0],
    setDownPayment = _useState4[1];
  var _useState5 = (0, _react.useState)('5'),
    _useState6 = _slicedToArray(_useState5, 2),
    mortgageInterest = _useState6[0],
    setMortgageInterest = _useState6[1];
  var _useState7 = (0, _react.useState)('200000'),
    _useState8 = _slicedToArray(_useState7, 2),
    purchasePrice = _useState8[0],
    setPurchasePrice = _useState8[1];
  var _useState9 = (0, _react.useState)('1'),
    _useState10 = _slicedToArray(_useState9, 2),
    propertyTax = _useState10[0],
    setPropertyTax = _useState10[1];
  var _useState11 = (0, _react.useState)('2000'),
    _useState12 = _slicedToArray(_useState11, 2),
    rent = _useState12[0],
    setRent = _useState12[1];
  var _useState13 = (0, _react.useState)('1200'),
    _useState14 = _slicedToArray(_useState13, 2),
    insurance = _useState14[0],
    setInsurance = _useState14[1];
  var _useState15 = (0, _react.useState)('1.5'),
    _useState16 = _slicedToArray(_useState15, 2),
    appreciation = _useState16[0],
    setAppreciation = _useState16[1];
  var _useState17 = (0, _react.useState)('320'),
    _useState18 = _slicedToArray(_useState17, 2),
    otherExpenses = _useState18[0],
    setOtherExpenses = _useState18[1];

  // outputs
  var _getOutputs2 = _getOutputs({
      appreciation: appreciation,
      downPayment: downPayment,
      insurance: insurance,
      mortgageInterest: mortgageInterest,
      otherExpenses: otherExpenses,
      propertyTax: propertyTax,
      purchasePrice: purchasePrice,
      rent: rent,
      years: years
    }),
    capRate = _getOutputs2.capRate,
    grossYield = _getOutputs2.grossYield,
    roi = _getOutputs2.roi,
    annualReturn = _getOutputs2.annualReturn,
    totalReturn = _getOutputs2.totalReturn;
  var inputs = [{
    title: 'Purchase price',
    max: '3000000',
    min: '0',
    step: '50000',
    value: purchasePrice,
    leftAdornment: '$',
    onChange: setPurchasePrice,
    tooltipText: 'The amount paid by the investor for the rental property. The purchase price can be paid for in cash or be financed through a mortgage lender.'
  }, {
    title: 'Down payment',
    max: '100',
    min: '0',
    step: '5',
    value: downPayment,
    rightAdornment: '%',
    onChange: setDownPayment,
    tooltipText: 'A percentage of the purchase price that is paid upfront by the investor. A down payment between 20% and 30% is generally required for a rental property that will be rented out from day one.'
  }, {
    title: 'Mortgage rate',
    max: '10',
    min: '0',
    step: '0.5',
    value: mortgageInterest,
    rightAdornment: '%',
    onChange: setMortgageInterest,
    tooltipText: 'The annual cost to borrow money from a lender, expressed as a percentage rate.'
  }, {
    title: 'Property tax',
    max: '2.5',
    min: '0',
    step: '0.1',
    value: propertyTax,
    rightAdornment: '%',
    onChange: setPropertyTax,
    tooltipText: 'A tax expense paid on owned property. Property tax, which is usually based on the value of the property and land, may fluctuate.'
  }, {
    title: 'Rental income',
    max: '10000',
    min: '0',
    step: '250',
    value: rent,
    leftAdornment: '$',
    rightAdornment: '/mo',
    onChange: setRent,
    tooltipText: "A tenant's regular monthly payment to a landlord for the use of the property or land. Rent is generally the primary source of income on a rental property. Calculate a rent price for your rental property."
  }, {
    title: 'Appreciation',
    max: '10',
    min: '0',
    step: '0.1',
    value: appreciation,
    rightAdornment: '%',
    onChange: setAppreciation,
    tooltipText: 'The increase in value of a property over time, expressed as an annual percentage rate. As a home rises in value, the investor can earn profit from the appreciation. The national appreciation value averages at around 3.5% to 3.8% per year.'
  }, {
    title: 'Insurance',
    max: '2500',
    min: '0',
    step: '100',
    value: insurance,
    leftAdornment: '$',
    rightAdornment: '/yr',
    onChange: setInsurance,
    tooltipText: "Homeowners insurance protects the property owner's liability and insures the residence against damages and losses. The average annual premium on home insurance usually costs less than 1% of the purchase price. With rental property, there may be additional insurance coverage needed."
  }, {
    title: 'Other expenses',
    max: '2500',
    min: '0',
    step: '50',
    leftAdornment: '$',
    rightAdornment: '/mo',
    value: otherExpenses,
    onChange: setOtherExpenses,
    tooltipText: 'Any additional operating expenses that go into managing a rental property, like repair costs, maintenance costs, property management fees, HOA fees, advertising costs, utility costs or vacancy costs. You can use Zillow Rental Manager to help manage most of your landlording tasks to make getting paid easier.'
  }];
  var outputs = [{
    title: 'Gross Yield',
    tooltipText: 'Gross yield on a rental property is the percentage of profit before expenses have been deducted.',
    value: grossYield
  }, {
    title: 'Cap Rate',
    tooltipText: 'Capitalization rate, or cap rate, is the ratio of net operating income (NOI) in relation to the current market value of the home.',
    value: capRate
  }, {
    title: '1 Yr Cash ROI',
    tooltipText: 'The cash-on-cash return, or cash ROI, is the annual rate of return on a rental property based on the cash earned in relation to the cash invested.',
    value: roi
  }, {
    title: 'Annual Return',
    tooltipText: 'The gross yield of an investment is its profit before taxes and expenses are deducted.',
    value: annualReturn
  }];
  return {
    inputs: inputs,
    outputs: outputs,
    years: years,
    setYears: setYears,
    totalReturn: totalReturn
  };
};